import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Textarea,
  Select,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Tooltip,
  TableContainer
} from "@chakra-ui/react";
import axios from "axios";
import apiUrl from "variables/api";
import { toast } from "react-toastify";

export default function BulkAddMarksModal({
  isOpen,
  onClose,
  usersData,
  fetchMarksData,
  peoples,
}) {
  const [comment, setComment] = useState("");
  const [color, setColor] = useState("");
  const [marks, setMarks] = useState({});

  const handleMarkChange = (userId, value) => {
    setMarks((prevMarks) => ({
      ...prevMarks,
      [userId]: value,
    }));
  };

  const handleSave = () => {
    if (!comment) {
      toast.error("Komentarz nie może być pusty");
      return;
    }

    if (!color) {
      toast.error("Kolor nie może być pusty");
      return;
    }
    
    const marksData = Object.keys(marks).map((userId) => ({
      mark: marks[userId],
      user: userId,
      color,
      comment,
    }));

    axios
      .post(apiUrl + "/data/school/company/marks/add/multi", marksData, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        toast.success("Pomyślnie dodano oceny");
        fetchMarksData();
        onClose();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas dodawania ocen");
      });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Masowe dodawanie ocen</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" gap="4">
            <Textarea
              placeholder="Komentarz"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              mb={3}
            />
            <Select
              placeholder="Wybierz kolor"
              value={color}
              onChange={(e) => setColor(e.target.value)}
              mb={3}
            >
              <option value="1">Czerwony</option>
              <option value="2">Zielony</option>
              <option value="3">Fioletowy</option>
              <option value="4">Żółty</option>
              <option value="5">Niebieski</option>
            </Select>
            <TableContainer>
              <Table variant="striped">
                <Thead>
                  <Tr>
                    <Th>Użytkownik</Th>
                    <Th>Ocena</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {usersData.map((user) => {
                    if (user.archived) return null;
                    return (
                      <Tr key={user.id}>
                        <Td>
                          <Tooltip
                            label={`Login: ${user.login}`}
                            hasArrow
                            placement="top"
                          >
                            {peoples.find(
                              (people) => people.value === user.userID
                            )?.label || "Nie odnaleziono użytkownika"}
                          </Tooltip>
                        </Td>
                        <Td>
                          <Input
                            placeholder="Ocena"
                            value={marks[user.id] || ""}
                            onChange={(e) =>
                              handleMarkChange(user.id, e.target.value)
                            }
                          />
                        </Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="red" mr={3} onClick={onClose}>
            Anuluj
          </Button>
          <Button colorScheme="green" onClick={handleSave}>
            Dodaj oceny
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
